import { render, staticRenderFns } from "./DepositSection.vue?vue&type=template&id=0b3ed69a&scoped=true"
import script from "./DepositSection.vue?vue&type=script&lang=js"
export * from "./DepositSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ed69a",
  null
  
)

export default component.exports